// Slice-10 /me profile screen. Shows the signed-in user's identity,
// IdP issuer, and current permission grant. Useful as a smoke test
// the SPA can hit immediately post-login to validate the access token.

import { useAuth } from "../auth/AuthContext";
import { useI18n } from "../i18n/I18nContext";

export function ProfileScreen(): JSX.Element {
  const { user } = useAuth();
  const { t } = useI18n();

  if (!user) {
    return <p>{t("login.discovering")}</p>;
  }

  return (
    <div>
      <h1>{t("me.heading")}</h1>
      <div className="rc-card" style={{ marginBottom: 16 }}>
        <p style={{ marginTop: 0 }}><strong>{user.displayName}</strong></p>
        <p
          data-testid="profile-email"
          style={{ color: "var(--rc-color-text-muted)", margin: 0 }}
        >
          {user.email}
        </p>
      </div>
      <h2 style={{ marginTop: 24 }}>{t("me.permissions")}</h2>
      <div className="rc-card">
        {user.uiHints.length === 0 ? (
          <p style={{ color: "var(--rc-color-text-muted)" }}>—</p>
        ) : (
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {user.uiHints.map((p) => (
              <li key={p}><code>{p}</code></li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
